/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Read_Only_DescriptionInputs */



/**
* | output |
* | --- |
* | "You can read this project's chats and files, but not start a chat here. Opening an existing chat and sending a message creates your own copy in your personal..." |
*
* @param {Project_Read_Only_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_read_only_description = /** @type {((inputs?: Project_Read_Only_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Read_Only_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie können die Chats und Dateien dieses Projekts lesen, aber hier keinen Chat starten. Wenn Sie einen bestehenden Chat öffnen und eine Nachricht senden, wird eine eigene Kopie in Ihrem persönlichen Projekt erstellt.")
	return /** @type {LocalizedString} */ ("You can read this project's chats and files, but not start a chat here. Opening an existing chat and sending a message creates your own copy in your personal project.")
});